// extracted by mini-css-extract-plugin
export default {"link":"style_link__YXOs4","centerGrid":"style_centerGrid__SdhvY","img":"style_img__vyhra","namegame":"style_namegame__Dwods","center":"style_center__4vxWd"};